import { Link } from 'react-router-dom';
import Arrow from '../../../components/ui/Arrow';
import SectionIntro from '../../../components/ui/SectionIntro';
import { brand } from '../../../content/site';
import { localizedPath, useLocale, useMessages } from '../../../i18n/locale';
import FadeInOnScroll from '../../../components/effects/FadeInOnScroll';

export default function OpenSourceSection() {
  const locale = useLocale();
  const copy = useMessages().home.openSource;
  return (
    <section id="open-source" className="open-section section-pad">
      <div className="container">
        <SectionIntro title={copy.title} description={copy.description} />
        <FadeInOnScroll className="open-layout" delay={100}>
          <div className="code-window">
            <div className="code-window__bar">
              <span className="window-dots">
                <i />
                <i />
                <i />
              </span>
              <span>{brand.name.toLowerCase()} / ecosystem.ts</span>
              <span className="window-tag">{copy.public}</span>
            </div>
            <div className="code-window__body">
              <div className="code-lines">
                <span>01</span>
                <span>02</span>
                <span>03</span>
                <span>04</span>
                <span>05</span>
                <span>06</span>
                <span>07</span>
                <span>08</span>
                <span>09</span>
              </div>
              <pre>
                <code>
                  <span className="code-purple">const</span> ecosystem = {'{'}
                  {'\n'} <span className="code-green">products</span>: buildWithPurpose(),{'\n'}{' '}
                  <span className="code-green">source</span>: shareWhatWeLearn(),{'\n'}{' '}
                  <span className="code-green">community</span>: growTogether(),{'\n'}
                  {'}'};{'\n\n'}
                  <span className="code-purple">export default</span> ecosystem;
                </code>
              </pre>
            </div>
            <div className="code-window__bottom">
              <span className="pulse-dot" /> {copy.footer} <span>© {brand.name}</span>
            </div>
          </div>
          <div className="open-features">
            {copy.features.map(([title, description]) => (
              <div key={title}>
                <h3>{title}</h3>
                <p>{description}</p>
              </div>
            ))}
          </div>
        </FadeInOnScroll>
        <div className="section-after">
          <span className="long-rule" />
          <Link className="text-link" to={localizedPath(locale, '/open-source')}>
            {copy.explore} <Arrow />
          </Link>
        </div>
      </div>
    </section>
  );
}
